import classname from "classname"

import Icon from "../../../../../../Icon"

import "./MonthStatus.less"

const MonthStatus = ({ icon, variant }) => {
  return (
    <div className={classname("vamp-month-status", variant)}>
      <Icon className="icon" type={icon} />
    </div>
  )
}

export default MonthStatus
